import { render } from "./electricity.vue?vue&type=template&id=c51c41f4&ts=true"
import script from "./electricity.vue?vue&type=script&lang=ts"
export * from "./electricity.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__